/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_AuthInputs */

const en_svchip_auth = /** @type {(inputs: Svchip_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth`)
};

const ar_svchip_auth = /** @type {(inputs: Svchip_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المصادقة`)
};

const bn_svchip_auth = /** @type {(inputs: Svchip_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অথ`)
};

const de_svchip_auth = /** @type {(inputs: Svchip_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth`)
};

const es_svchip_auth = /** @type {(inputs: Svchip_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticación`)
};

const fr_svchip_auth = /** @type {(inputs: Svchip_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification`)
};

const pt_svchip_auth = /** @type {(inputs: Svchip_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticação`)
};

const zh_svchip_auth = /** @type {(inputs: Svchip_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`授权`)
};

const tr_svchip_auth = /** @type {(inputs: Svchip_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth`)
};

const ru_svchip_auth = /** @type {(inputs: Svchip_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аутентификация`)
};

const pl_svchip_auth = /** @type {(inputs: Svchip_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autoryt`)
};

/**
* | output |
* | --- |
* | "Auth" |
*
* @param {Svchip_AuthInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_auth = /** @type {((inputs?: Svchip_AuthInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_AuthInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_auth(inputs)
	if (locale === "bn") return bn_svchip_auth(inputs)
	if (locale === "de") return de_svchip_auth(inputs)
	if (locale === "es") return es_svchip_auth(inputs)
	if (locale === "fr") return fr_svchip_auth(inputs)
	if (locale === "pt") return pt_svchip_auth(inputs)
	if (locale === "zh") return zh_svchip_auth(inputs)
	if (locale === "tr") return tr_svchip_auth(inputs)
	if (locale === "ru") return ru_svchip_auth(inputs)
	if (locale === "pl") return pl_svchip_auth(inputs)
	return en_svchip_auth(inputs)
});